export type CustomOptionsInputModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onChange: (value: CustomOptionItem) => void;
    options: CustomOptionItem[];
};

export type CustomOptionItem = {
    value: string;
    type: CustomOptionItemType;
    text: string;
    inputValue?: string;
};
export enum CustomOptionItemType {
    Custom = 'custom',
    Standard = 'standard',
    Trigger = 'trigger',
}
